/*
 * File: DriveHistorySummaryStats.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

interface DriveHistorySummaryStatsProps {
  /**
   * Number of completed drives
   */
  completedCount: number;

  /**
   * Number of no-show drives
   */
  noShowCount: number;

  /**
   * Number of no-permit drives
   */
  noPermitCount: number;

  /**
   * Number of upcoming drives
   */
  upcomingCount: number;

  /**
   * Number of canceled drives
   */
  canceledCount: number;
}

/**
 * Summary statistics chips for drive history
 */
export default function DriveHistorySummaryStats({
  completedCount,
  noShowCount,
  noPermitCount,
  upcomingCount,
  canceledCount,
}: DriveHistorySummaryStatsProps) {
  return (
    <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
      {completedCount > 0 && (
        <Chip label={`${completedCount} Completed`} size="small" color="success" variant="outlined" />
      )}
      {noShowCount > 0 && <Chip label={`${noShowCount} No-Shows`} size="small" color="error" variant="outlined" />}
      {noPermitCount > 0 && (
        <Chip label={`${noPermitCount} No Permits`} size="small" color="warning" variant="outlined" />
      )}
      {upcomingCount > 0 && <Chip label={`${upcomingCount} Upcoming`} size="small" color="info" variant="outlined" />}
      {canceledCount > 0 && (
        <Chip label={`${canceledCount} Canceled`} size="small" color="default" variant="outlined" />
      )}
    </Box>
  );
}
